import React from 'react';
import styled from 'styled-components';
import { CircularProgress } from '@mui/material';

const Container = styled.div`
    position: ${props => (props.fullScreen ? 'fixed' : 'absolute')};
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(255, 255, 255, ${props => props.faint ? 0.0 : 0.8});
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
`;

export default function LoadingMask({ visible = true, fullScreen = true, hideSpinner = false, faint = false }) {
    if (!visible) {
        return null;
    }

    return (
        <Container fullScreen={fullScreen} faint={faint}>
            {!hideSpinner && <CircularProgress />}
        </Container>
    );
}
